/*
 * Sort by Discount - Allens Swimwear
 * Works with templates/collection.discount.json (loaded via ?view=discount) and the
 * discount sort logic in snippets/collection-banner-adv.liquid.
 *
 * - Switches between the discount view and the normal sort options.
 * - Each page of 250 products is sorted by discount (biggest saving first) in Liquid.
 *   If MAX_PAGES is above 1, further pages are fetched in the background and merged.
 * - Collections bigger than the cap get a 'View more products' link to the next batch.
 * - Optional discount range from the URL, e.g. &discount_min=30&discount_max=35
 *   (whole percentages, inclusive). Only works on the discount view.
 * - Discount band pills (snippets/discount-band-pills.liquid): filter without a page
 *   reload and refresh their counts whenever filters change.
 */
(function () {
    if (window.__allensSortByDiscount) return;
    window.__allensSortByDiscount = true;

    var MAX_PAGES = 1; // 1 x 250 = 250 products sorted together, no background loading
    var PAGE_SIZE = 250;
    var RANGE_PARAMS = ['discount_min', 'discount_max'];

    function getParams() {
        return new URLSearchParams(window.location.search);
    }

    function isDiscountView() {
        return getParams().get('view') === 'discount';
    }

    function cleanUrl(url) {
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        return url;
    }

    // Keep the discount view (and any discount range) on a URL the theme or Shopify generated.
    function keepDiscountParams(url) {
        if (!isDiscountView()) return url;
        var current = getParams();
        url.searchParams.set('view', 'discount');
        RANGE_PARAMS.forEach(function (name) {
            if (current.get(name)) url.searchParams.set(name, current.get(name));
        });
        return url;
    }

    /* ---------- Clicks: band pills, sort dropdown and filter links ---------- */

    document.addEventListener('click', function (event) {
        // Discount band pills: filter with the theme's AJAX filtering when available.
        var pill = event.target.closest('a.discount-band-pill');
        if (pill) {
            var pillUrl = keepDiscountParams(cleanUrl(new URL(pill.href, window.location.origin)));
            if (typeof CollectionFiltersForm !== 'undefined' && typeof CollectionFiltersForm.renderPage === 'function') {
                event.preventDefault();
                event.stopImmediatePropagation();
                CollectionFiltersForm.renderPage(pillUrl.searchParams.toString(), event);
            } else {
                pill.href = pillUrl.toString();
            }
            return;
        }

        var discountItem = event.target.closest('[data-sort-by-discount]');
        if (discountItem) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (isDiscountView()) return;
            var url = cleanUrl(new URL(window.location.href));
            url.searchParams.set('view', 'discount');
            url.searchParams.delete('sort_by');
            window.location.href = url.toString();
            return;
        }

        if (!isDiscountView()) return;

        var sortItem = event.target.closest('[data-sort-by-item]');
        if (sortItem) {
            var text = sortItem.querySelector('.text');
            var value = text ? text.getAttribute('data-href') : null;
            if (!value) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            var sortUrl = cleanUrl(new URL(window.location.href));
            sortUrl.searchParams.delete('view');
            RANGE_PARAMS.forEach(function (name) { sortUrl.searchParams.delete(name); });
            sortUrl.searchParams.set('sort_by', value);
            window.location.href = sortUrl.toString();
            return;
        }

        // Removing an active filter: keep the discount view and any discount range.
        var removeLink = event.target.closest('facet-remove a, .refined-widgets a');
        if (removeLink && removeLink.getAttribute('href')) {
            removeLink.href = keepDiscountParams(new URL(removeLink.href, window.location.origin)).toString();
        }
    }, true);

    // Filters build their URL from the filter form, so add the discount settings to it.
    function addHiddenInputsToFilterForms() {
        if (!isDiscountView()) return;
        var params = getParams();
        var values = { view: 'discount' };
        RANGE_PARAMS.forEach(function (name) {
            if (params.get(name)) values[name] = params.get(name);
        });
        document.querySelectorAll('collection-filters-form form').forEach(function (form) {
            Object.keys(values).forEach(function (name) {
                if (form.querySelector('input[name="' + name + '"]')) return;
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = values[name];
                form.appendChild(input);
            });
        });
    }

    /* ---------- Band pills: refresh after AJAX filtering ---------- */

    function refreshPills(html) {
        try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-discount-band-pills]');
            var current = document.querySelector('[data-discount-band-pills]');
            if (current && fresh) {
                current.replaceWith(fresh);
            } else if (current && !fresh) {
                current.remove();
            } else if (!current && fresh) {
                var toolbar = document.querySelector('#CollectionProductGrid toolbar-item');
                if (toolbar) toolbar.parentNode.insertBefore(fresh, toolbar.nextSibling);
            }
        } catch (error) {
            console.warn('Sort by discount: could not refresh discount pills', error);
        }
    }

    /* ---------- Merge, sort and range-filter the grid ---------- */

    function getRange() {
        var params = getParams();
        var min = parseFloat(params.get('discount_min'));
        var max = parseFloat(params.get('discount_max'));
        // data-discount is stored in tenths of a percent (35% = 350)
        return {
            min: isNaN(min) ? null : Math.round(min * 10),
            max: isNaN(max) ? null : Math.round(max * 10)
        };
    }

    function productItems(root) {
        return Array.prototype.slice.call(root.querySelectorAll('li.product[data-discount]'));
    }

    function num(value) {
        var n = parseInt(value, 10);
        return isNaN(n) ? 0 : n;
    }

    function refreshCardFeatures() {
        try {
            if (typeof CollectionFiltersForm !== 'undefined') {
                if (window.wishlist && window.wishlist.show && CollectionFiltersForm.setLocalStorageProductForWishlist) {
                    CollectionFiltersForm.setLocalStorageProductForWishlist();
                }
                if (window.compare && window.compare.show && CollectionFiltersForm.setLocalStorageProductForCompare && window.jQuery) {
                    CollectionFiltersForm.setLocalStorageProductForCompare({ link: window.jQuery('[data-compare-link]'), onComplete: null });
                }
                if (CollectionFiltersForm.checkNeedToConvertCurrency && CollectionFiltersForm.checkNeedToConvertCurrency() && window.Currency && window.jQuery) {
                    Currency.convertAll(window.shop_currency, window.jQuery('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            }
            if (window.jQuery) window.jQuery('.productListing .card .swatch-label.is-active').trigger('click');
            if (window.sharedFunctions && window.sharedFunctions.swapHoverVideoProductCard) window.sharedFunctions.swapHoverVideoProductCard();
        } catch (error) {
            console.warn('Sort by discount: could not refresh product card features', error);
        }
    }

    // Replace the theme's pagination with a plain link to the next batch, keeping the discount view.
    function showNextBatchLink(collectionEl, firstShown, lastShown, nextPage, hasNext) {
        var old = collectionEl.querySelector('.discount-next-batch');
        if (old) old.remove();
        var wrapper = document.createElement('div');
        wrapper.className = 'pagination-wrapper text-center discount-next-batch';
        var html = '<p>Showing products ' + firstShown + ' to ' + lastShown + ', sorted by discount.</p>';
        if (hasNext) {
            var url = new URL(window.location.href);
            url.searchParams.delete('section_id');
            url.searchParams.set('page', nextPage);
            html += '<a class="button button-1" href="' + url.toString() + '">View more products</a>';
        }
        wrapper.innerHTML = html;
        collectionEl.appendChild(wrapper);
    }

    var running = false;

    async function buildDiscountGrid() {
        if (!isDiscountView() || running) return;
        var grid = document.getElementById('main-collection-product-grid');
        if (!grid || !grid.hasAttribute('data-discount-pages')) return;

        var range = getRange();
        var realPages = num(grid.getAttribute('data-discount-pages')) || 1;
        var currentPage = num(grid.getAttribute('data-discount-current')) || 1;
        var totalPages = Math.min(realPages, MAX_PAGES);
        var needsMerge = totalPages > 1 && currentPage === 1;
        var needsPaging = realPages > 1 && realPages > (currentPage === 1 ? totalPages : 1);
        var needsRange = range.min !== null || range.max !== null;
        if (!needsMerge && !needsPaging && !needsRange) return;

        running = true;
        if (needsMerge) document.body.classList.add('has-halo-loader');

        try {
            var items = productItems(grid);
            var collectionEl = grid.closest('.collection');

            if (needsMerge) {
                var sectionId = grid.dataset.id;
                var requests = [];
                for (var page = 2; page <= totalPages; page++) {
                    var url = new URL(window.location.href);
                    url.searchParams.set('page', page);
                    url.searchParams.set('section_id', sectionId);
                    requests.push(fetch(url.toString()).then(function (response) { return response.text(); }));
                }
                var pages = await Promise.all(requests);
                pages.forEach(function (html) {
                    var doc = new DOMParser().parseFromString(html, 'text/html');
                    var pageGrid = doc.getElementById('main-collection-product-grid');
                    if (pageGrid) items = items.concat(productItems(pageGrid));
                });
            }

            if ((needsMerge || needsPaging) && collectionEl) {
                var pagination = collectionEl.querySelector('.pagination-wrapper:not(.discount-next-batch)');
                if (pagination) pagination.remove();
                var lastPageShown = currentPage === 1 ? totalPages : currentPage;
                var firstShown = currentPage === 1 ? 1 : (currentPage - 1) * PAGE_SIZE + 1;
                var lastShown = firstShown + items.length - 1;
                showNextBatchLink(collectionEl, firstShown, lastShown, lastPageShown + 1, lastPageShown < realPages);
            }
            grid.removeAttribute('data-discount-pages');

            // Biggest discount first; equal discounts keep the collection's normal order.
            items.sort(function (a, b) {
                var diff = num(b.dataset.discount) - num(a.dataset.discount);
                return diff !== 0 ? diff : num(a.dataset.position) - num(b.dataset.position);
            });

            var visible = items.filter(function (li) {
                var value = num(li.dataset.discount);
                if (range.min !== null && value < range.min) return false;
                if (range.max !== null && value > range.max) return false;
                return true;
            });

            if (needsMerge || needsRange) {
                // Remember where the promo banners sit so they stay in place.
                var banners = [];
                Array.prototype.forEach.call(grid.children, function (el, index) {
                    if (el.classList.contains('banner')) banners.push({ el: el, index: index });
                });

                var fragment = document.createDocumentFragment();
                visible.forEach(function (li) { fragment.appendChild(li); });
                grid.innerHTML = '';
                grid.appendChild(fragment);

                if (visible.length) {
                    banners.forEach(function (banner) {
                        grid.insertBefore(banner.el, grid.children[banner.index] || null);
                    });
                }

                var existingMessage = document.querySelector('.discount-empty-message');
                if (existingMessage) existingMessage.remove();
                if (!visible.length) {
                    var message = document.createElement('p');
                    message.className = 'discount-empty-message';
                    message.textContent = 'No products in this collection match that discount range.';
                    grid.parentNode.insertBefore(message, grid.nextSibling);
                }

                var count = document.querySelector('.results-count .count');
                if (count) count.textContent = visible.length;

                refreshCardFeatures();
            }
        } catch (error) {
            console.warn('Sort by discount: could not update the collection grid', error);
        } finally {
            document.body.classList.remove('has-halo-loader');
            running = false;
        }
    }

    // Re-run after the theme re-renders the grid when a filter (or pill) is applied.
    function patchFilterRendering() {
        if (typeof CollectionFiltersForm === 'undefined' || CollectionFiltersForm.__discountPatched) return;
        var originalRender = CollectionFiltersForm.renderProductGrid;
        CollectionFiltersForm.renderProductGrid = function (html) {
            var result = originalRender.apply(this, arguments);
            refreshPills(html);
            buildDiscountGrid();
            return result;
        };
        CollectionFiltersForm.__discountPatched = true;
    }

    function init() {
        addHiddenInputsToFilterForms();
        patchFilterRendering();
        buildDiscountGrid();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    window.addEventListener('load', patchFilterRendering);
})();
